import { createContext } from 'react';
import type { Game, ChallengeWithProgress, ChallengeContextState } from '@/types/game';

export interface GameRegistryContextType {
  // Game registry state
  games: Game[];
  loading: boolean;
  error: Error | null;
  fetchGames: () => Promise<void>;
  refreshGames: () => Promise<void>;
  getGameById: (gameId: string) => Game | undefined;
  
  // Challenge data state
  challengeState: ChallengeContextState;
  
  // Challenge methods
  getChallengesForGame: (gameId: string) => Promise<ChallengeWithProgress[]>;
  refreshChallenges: (gameId: string) => Promise<void>;
  invalidateCache: (gameId?: string) => void;
  scheduleNearMidnightRefresh: (gameId: string) => void;
}

export const GameRegistryContext = createContext<GameRegistryContextType | undefined>(undefined);